/**
 * Gate for `[view_context]` publisher / send-time logs.
 *
 * Stays off by default in production: every scroll, filter change, or
 * chat send fires a log, so an unconditional `console.log` would flood
 * devtools. Opt in either at build time via the env var, or at runtime
 * via `localStorage.setItem("ai.viewContext.debug", "1")`.
 */
export function isViewContextDebugEnabled(): boolean {
  // `process` may not be declared in this package's typing context
  // (apps/web is consumed by Next.js apps where NEXT_PUBLIC_* gets
  // substituted at build time). Read it through globalThis so the
  // check still works wherever it's bundled.
  const proc = (
    globalThis as {
      process?: { env?: Record<string, string | undefined> }
    }
  ).process
  if (proc?.env?.NEXT_PUBLIC_AI_VIEW_CONTEXT_DEBUG === "1") return true
  if (typeof window !== "undefined") {
    try {
      return window.localStorage.getItem("ai.viewContext.debug") === "1"
    } catch {
      return false
    }
  }
  return false
}
